import axios from "axios";
import Config from "src/config";

export default function v3_actionGetAgentFeedbacks(params) {
    return axios({
        method: "get",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v3/ai/feedback`,
        params
    });
}
